import * as fromRouter from "@ngrx/router-store";
import { createFeatureSelector } from "@ngrx/store";
import { OfiRoute } from "src/app/modules/ofi-router/ofi-route";

export interface State {
  router: fromRouter.RouterReducerState<any>;
}

export const selectRouter = createFeatureSelector<
  fromRouter.RouterReducerState<OfiRoute>
>("router");
